/* global axios */
import ApiClient from './ApiClient';

class Information extends ApiClient {
  constructor() {
    super('information', { accountScoped: true, apiVersion: 'v2' });
  }

  // 获取用户提问消息
  getUserQuestionsList({ page, from, to }) {
    return axios.get(`${this.url}/messages`, {
      params: { page, since: from, until: to },
    });
  }

  // 获取消息标签
  getQuestionsTagList({ page, from, to }) {
    return axios.get(`${this.url}/message_tags`, {
      params: { page, since: from, until: to },
    });
  }

  // 获取消息分类
  getQuestionsTypeList({ page, from, to }) {
    return axios.get(`${this.url}/message_types`, {
      params: { page, since: from, until: to },
    });
  }

  // 获取功能触发
  getFunctionTriggerList({ page, from, to }) {
    return axios.get(`${this.url}/function_trigger`, {
      params: { page, since: from, until: to },
    });
  }

  // 获取机器人未触发
  getRobotNotMatchedList({ page, from, to }) {
    return axios.get(`${this.url}/robot_not_matched`, {
      params: { page, since: from, until: to },
    });
  }

  // 获取会话消息
  getMessageData({ id }) {
    return axios.get(`${this.url}/message_data`, {
      params: { id },
    });
  }
}

export default new Information();
